<template>
  <input type="range" v-model="newValue" />
</template>
<script>
export default {
  props: {
    value: String,
  },
  computed: {
    newValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("input", newVal);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
input[type="range"] {
  -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
  width: 100%; /* Specific width is required for Firefox. */
  background: transparent; /* Otherwise white in Chrome */

  /* Unsetting Styles: */
  ::-webkit-slider-thumb {
    -webkit-appearance: none;
  }

  :focus {
    outline: none; /* Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. */
  }

  ::-ms-track {
    width: 100%;
    cursor: pointer;

    /* Hides the slider so custom styles can be added */
    background: transparent;
    border-color: transparent;
    color: transparent;
  }

  /* Overriding Styles: */
  /* THUMB -------------------------- */
  /* Special styling for WebKit/Blink */
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: var(--color-primary);
    cursor: pointer;
    margin-top: -8px;
    /* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
  }

  /* All the same stuff for Firefox */
  &::-moz-range-thumb {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: var(--color-primary);
    cursor: pointer;
  }

  /* All the same stuff for IE */
  &::-ms-thumb {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: var(--color-primary);
    cursor: pointer;
  }

  /* TRACK -------------------------- */
  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    background: var(--color-secondary-light);
    border-radius: 100px;
  }

  /* &:focus::-webkit-slider-runnable-track {
        background: #367ebd;
      } */

  &::-moz-range-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    background: var(--color-secondary-light);
    border-radius: 100px;
  }

  &::-ms-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    border-width: 16px 0;
    color: transparent;
  }
  &::-ms-fill-lower {
    background: var(--color-secondary-light);
    border-radius: 100px;
  }
  /* &:focus::-ms-fill-lower {
        background: var(--color-secondary-light);
      } */
  &::-ms-fill-upper {
    background: var(--color-secondary-light);
    border-radius: 100px;
  }
  /* &:focus::-ms-fill-upper {
        background: var(--color-secondary-light);
    } */
}
</style>
